import { createEntityAdapter } from '@ngrx/entity';
import { CampagnePatrimoineEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<CampagnePatrimoineEntityState>;

export const adapter = createEntityAdapter<CampagnePatrimoineEntityState>({
  selectId: o => o.idCampagnePatrimoine
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const campagnePatrimoineFeatureKey = 'campagnePatrimoine';
